(function (sectionName) {
  function init(root) {
    if (!root || root.dataset.accInit) return;
    root.dataset.accInit = '1';

    var screens = Array.prototype.slice.call(root.querySelectorAll('.acc-pp__screen'));
    var order = ['intro', 'questions', 'prep', 'result'];
    var TOTAL_Q = 5;
    var currentQ = 1;

    var qSection = root.querySelector('.acc-pp__screen[data-screen-id="questions"]');
    var panels = qSection ? Array.prototype.slice.call(qSection.querySelectorAll('.acc-q__panel')) : [];
    var progressFill = qSection && qSection.querySelector('[data-progress-fill]');
    var progressLabel = qSection && qSection.querySelector('[data-progress-label]');
    var nextBtn = qSection && qSection.querySelector('[data-action="qnext"]');
    var nextLabel = qSection && qSection.querySelector('[data-next-label]');
    var backBtn = qSection && qSection.querySelector('[data-action="qback"]');

    function screenEl(id) {
      return root.querySelector('.acc-pp__screen[data-screen-id="' + id + '"]');
    }

    function scrollToTop() {
      try {
        var top = root.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'auto' });
      } catch (e) {}
    }

    function show(id) {
      screens.forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.screenId === id);
      });
      root.dataset.screen = id;
      if (id === 'questions') setQuestion(currentQ);
      scrollToTop();
      if (id === 'prep') runPrep();
    }

    /* ---------- answers ---------- */
    var answers = { q1: null, q2: null, q3: [], q4: null, q5: null };

    function readQ3() {
      var boxes = root.querySelectorAll('input[name="acc_q3"]:checked');
      answers.q3 = Array.prototype.map.call(boxes, function (b) { return b.value; });
    }

    function questionAnswered(qid) {
      if (qid === 'q3') return answers.q3.length > 0;
      return !!answers[qid];
    }

    function updateNextState() {
      if (!nextBtn) return;
      var ok = questionAnswered('q' + currentQ);
      nextBtn.disabled = !ok;
      nextBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    }

    /* ---------- question switching (panels crossfade; progress persists) ---------- */
    function setQuestion(n) {
      currentQ = n;
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.q === String(n));
      });
      if (progressFill) progressFill.style.width = (n / TOTAL_Q) * 100 + '%';
      if (progressLabel) progressLabel.textContent = 'Question ' + n + ' of ' + TOTAL_Q;
      if (backBtn) backBtn.hidden = n === 1;
      if (nextLabel) nextLabel.textContent = n === TOTAL_Q ? 'See my results' : 'Next';
      updateNextState();
    }

    /* ---------- input handling (single delegated listener for all questions) ---------- */
    if (qSection) {
      qSection.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.name || t.name.indexOf('acc_q') !== 0) return;
        var qid = t.name.replace('acc_', ''); // q1..q5
        var panel = t.closest('.acc-q__panel');

        if (qid === 'q3') {
          if (t.checked) {
            if (t.value === 'nothing') {
              qSection.querySelectorAll('input[name="acc_q3"]').forEach(function (b) {
                if (b.value !== 'nothing') b.checked = false;
              });
            } else {
              var nothing = qSection.querySelector('input[name="acc_q3"][value="nothing"]');
              if (nothing) nothing.checked = false;
            }
          }
          readQ3();
          if (panel) syncSelectedMulti(panel);
        } else {
          answers[qid] = t.value;
          if (panel) syncSelected(panel, t.name);
        }
        if (qid === 'q' + currentQ) updateNextState();
      });
    }

    function syncSelected(scope, name) {
      scope.querySelectorAll('.acc-card').forEach(function (card) {
        var input = card.querySelector('input[name="' + name + '"]');
        card.classList.toggle('is-selected', !!(input && input.checked));
      });
    }
    function syncSelectedMulti(scope) {
      scope.querySelectorAll('.acc-card').forEach(function (card) {
        var input = card.querySelector('input');
        card.classList.toggle('is-selected', !!(input && input.checked));
      });
    }

    /* ---------- navigation buttons ---------- */
    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-action]');
      if (!el || !root.contains(el)) return;
      var action = el.dataset.action;
      if (action === 'start') { currentQ = 1; show('questions'); }
      else if (action === 'qnext') {
        if (el.disabled) return;
        if (currentQ < TOTAL_Q) setQuestion(currentQ + 1), scrollToTop();
        else show('prep');
      }
      else if (action === 'qback') {
        if (currentQ > 1) { setQuestion(currentQ - 1); scrollToTop(); }
        else show('intro');
      }
      else if (action === 'retake') {
        try { history.replaceState({}, '', urlWithoutResult()); } catch (e) {}
        resetQuiz();
      }
    });

    /* ---------- result logic ---------- */
    var BREED = {
      dachshund: 'Dachshund',
      'french-bulldog': 'French Bulldog',
      corgi: 'Corgi',
      beagle: 'Beagle',
      'basset-hound': 'Basset Hound',
      other: 'dog'
    };
    function breedName() { return BREED[answers.q1] || 'dog'; }
    function ageLine() {
      var b = breedName();
      switch (answers.q5) {
        case 'under3': return 'At this age, degeneration is already underway silently';
        case '3to7': return 'This is the peak risk window for your ' + b;
        case '8plus': return 'At this age, inflammation levels are at their highest';
        default: return '';
      }
    }

    function computeResult() {
      var q3 = answers.q3 || [];

      if (answers.q2 === 'noticed') return 2;           // Symptomatic
      if (answers.q2 === 'episode' || answers.q2 === 'middle') return 3; // Post-Episode

      // q2 === 'fine' -> Prevention (baseline), overridden by Supplement-Fatigued
      var nonNothing = q3.filter(function (v) { return v !== 'nothing'; });
      var hasGlucosamine = q3.indexOf('glucosamine') !== -1;
      var hasOther = q3.indexOf('other') !== -1;
      var multipleSupplements = nonNothing.length > 1; // 2+ non-"Nothing yet" selections
      var suppFatigued =
        hasGlucosamine ||                                                   // glucosamine chews, or
        ((hasOther || multipleSupplements) && answers.q4 === 'wrong-thing'); // "other"/multiple + wrong-thing
      if (suppFatigued) return 4;                       // Supplement-Fatigued overrides Prevention
      return 1;                                         // Prevention
    }

    function applyPlaceholders(scope) {
      var b = breedName();
      var line = ageLine();
      scope.querySelectorAll('[data-tpl]').forEach(function (node) {
        var tpl = node.getAttribute('data-tpl');
        node.textContent = tpl
          .replace(/\[Age line\]/g, line)
          .replace(/\[Breed\]/g, b);
      });
    }

    /* ---------- result URL history ---------- */
    var STORAGE_KEY = 'acc_pp_lp_03_answers';
    var RESULT_SLUG = { 1: 'prevention', 2: 'symptomatic', 3: 'post-episode', 4: 'supplement-fatigued' };
    var SLUG_RESULT = { prevention: 1, symptomatic: 2, 'post-episode': 3, 'supplement-fatigued': 4 };

    function persistAnswers() {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(answers)); } catch (e) {}
    }
    function restoreAnswers() {
      try {
        var s = sessionStorage.getItem(STORAGE_KEY);
        if (s) answers = JSON.parse(s);
      } catch (e) {}
    }
    function urlWithResult(n) {
      var u = new URL(window.location.href);
      u.searchParams.set('result', RESULT_SLUG[n]);
      return u.pathname + u.search + u.hash;
    }
    function urlWithoutResult() {
      var u = new URL(window.location.href);
      u.searchParams.delete('result');
      return u.pathname + u.search + u.hash;
    }
    function resultFromUrl() {
      try {
        var slug = new URL(window.location.href).searchParams.get('result');
        return slug && SLUG_RESULT[slug] ? SLUG_RESULT[slug] : null;
      } catch (e) { return null; }
    }

    function renderResultVariant(n) {
      var resultSc = screenEl('result');
      resultSc.querySelectorAll('.acc-result__variant').forEach(function (v) {
        var active = v.dataset.result === String(n);
        v.classList.toggle('is-active', active);
        if (active) applyPlaceholders(v);
      });
    }

    // show a result; push=true creates a history entry with the unique ?result= param
    function showResult(n, push) {
      renderResultVariant(n);
      show('result');
      if (push) {
        persistAnswers();
        try { history.pushState({ accResult: n }, '', urlWithResult(n)); } catch (e) {}
      }
    }

    // browser back/forward
    window.addEventListener('popstate', function () {
      var n = resultFromUrl();
      if (n) {
        // landed on a result entry (e.g. Back from the product page) -> show it
        restoreAnswers();
        renderResultVariant(n);
        show('result');
      } else if (root.dataset.screen === 'result') {
        // Back off the result screen -> reset everything and show the entry screen
        resetQuiz();
      }
    });

    /* ---------- prep animation (10s) ---------- */
    var prepTimers = [];
    function clearPrep() {
      prepTimers.forEach(clearTimeout);
      prepTimers = [];
    }
    function runPrep() {
      clearPrep();
      var prep = screenEl('prep');
      var steps = Array.prototype.slice.call(prep.querySelectorAll('.acc-step'));
      var caption = prep.querySelector('.acc-prep__caption');
      var inner = prep.querySelector('.acc-prep');

      steps.forEach(function (s) { s.classList.remove('is-active', 'is-done'); });
      inner.classList.remove('is-running');
      void inner.offsetWidth;
      inner.classList.add('is-running');

      var STEP = 1000; // ms per step (5 steps = 5s total)
      steps.forEach(function (step, i) {
        prepTimers.push(setTimeout(function () {
          steps.forEach(function (s, j) {
            if (j < i) { s.classList.add('is-done'); s.classList.remove('is-active'); }
          });
          step.classList.add('is-active');
          step.classList.remove('is-done');
          if (caption) caption.textContent = (step.dataset.caption || step.querySelector('.acc-step__label').textContent) + '...';
        }, i * STEP));
      });
      prepTimers.push(setTimeout(function () {
        steps.forEach(function (s) { s.classList.add('is-done'); s.classList.remove('is-active'); });
      }, steps.length * STEP - 1));
      prepTimers.push(setTimeout(function () {
        showResult(computeResult(), true);
      }, steps.length * STEP));
    }

    /* ---------- retake ---------- */
    function resetQuiz() {
      clearPrep();
      root.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (i) { i.checked = false; });
      root.querySelectorAll('.acc-card.is-selected').forEach(function (c) { c.classList.remove('is-selected'); });
      answers = { q1: null, q2: null, q3: [], q4: null, q5: null };
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      setQuestion(1);
      show('intro');
    }

    /* ---------- init ---------- */
    setQuestion(1);
    var initResult = resultFromUrl();
    if (initResult) {
      // page (re)loaded directly on a result URL (e.g. Back from the product page)
      restoreAnswers();
      renderResultVariant(initResult);
      show('result');
    } else {
      show(root.dataset.screen || 'intro');
    }
  }

  function boot() {
    document.querySelectorAll('.acc-pp[data-section="' + sectionName + '"]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})('acc_pp_lp_03_01');
